import React from "react";
import {
  InteractiveChatMain,
  NarrativeMain,
  ActionsMain,
  AdvanceFinishMain,
  IntakeOutputMain,
  OrdersMain,
  PhysicalExamMain,
  PNOrdersMain,
  DocumentationMain,
  VitalSignMain,
  ProfileImageMain,
  VirtualPreceptorMain,
  Demographics,
  Appearance,
  DialogSettings,
  Character,
  NarrativeSetting,
  Description,
  AdvanceSetting,
} from "../../../storyboard/ManageAvailableTasks";

//Ending Page
import { EndingPageMain } from "../../../storyboard/EndingPage";

const components = {
  profile_image: ProfileImageMain,
  history: NarrativeMain,
  chat: InteractiveChatMain,
  vital: VitalSignMain,
  io: IntakeOutputMain,
  exam: PhysicalExamMain,
  orders: OrdersMain,
  pn: PNOrdersMain,
  documentation: DocumentationMain,
  actions: ActionsMain,
  advance: AdvanceFinishMain,
  virtual_preceptor: VirtualPreceptorMain,
  demographics: Demographics,
  appearance: Appearance,
  character: Character,
  dialog_settings: DialogSettings,
  narrative: NarrativeSetting,
  description: Description,
  advance_setting: AdvanceSetting,
};

const CaseTimelineRightPanel = ({ activeViewClass, timepointIdActive, ...props }) => {
  const Component = components[activeViewClass];
  const style = timepointIdActive === 9999 ? { width: "100%", marginLeft: "0" } : {};

  return (
    <div className="case-timelineCt__right position-relative" style={style}>
      {timepointIdActive === 9999 ? <EndingPageMain {...props} /> : Component && <Component {...props} activeViewClass={activeViewClass} />}
    </div>
  );
};

export default CaseTimelineRightPanel;